import React, { useState } from 'react';

// Styles & Assets
import styles from './CreateEventDialog.module.css';

// Services
import { setReminderTimeObject } from '../../../services/util';

// Hooks
import { useTranslation } from 'react-i18next';

// Components
import CancelConfirmButtons from '../../UI/CancelConfirmButtons/CancelConfirmButtons';
import SelectorSimple from '../../Helpers/SelectorSimple/SelectorSimple';
import Select from '../../UI/Select/Select';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { createTheme, ThemeProvider } from '@mui/material';
import HourSelector from '../../UI/HourSelector/HourSelector';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

// Interfaces
import { HH, mm } from '../../../interfaces/Time';
import { OptionElement } from '../../../interfaces/Input';

// Constants
const DURATION_MINUTES: number[] = [5, 10, 15, 30, 60]

const CreateEventDialog: React.FC = () => {

    const { t } = useTranslation();

    const [time, setTime] = useState<{ hours: HH | null, minutes: mm | null }>({ hours: null, minutes: null })
    const [duration, setDuration] = useState<number>();

    const newTheme = createTheme({
        components: {
            MuiInputBase: {
                styleOverrides: {
                    input: {
                        fontSize: '14px',
                        padding: '10px 0 10px 12px !important',
                        fontFamily: 'MontserratRegular',
                        minWidth: '100px'
                    },
                },
            },
            MuiInputAdornment: {
                styleOverrides: {
                    root: { margin: '0' }
                }
            }
        }
    });

    const handleChangeReminder = (hours: HH | null, minutes: mm | null) => {
        setTime(setReminderTimeObject(hours, minutes));
    };

    const handleClickDuration = (option: OptionElement<number>) => {
        setDuration(option.id);
    };

    const durationOptions: OptionElement<number>[] = DURATION_MINUTES.map((minutes) => ({
        id: minutes,
        label: minutes + ' ' + t('minutes')
    }))


    return (
        <div className='dialog'>
            <h1 className='dialogTitle' style={{ marginBottom: '2rem' }}>{t('create_appointment')}</h1>
            <div className={styles.grid}>
                <div>
                    <h2 className={styles.categoryTitle}>{t('patient')}</h2>
                    <Select
                        selector={(props) => <SelectorSimple {...props} />}
                        value={'124243 - Pepa Pérez Calabuig'}
                        options={[]}
                        onSelect={() => {/* */ }}
                    />
                </div>
                <div className={styles.twoRow}>
                    <div>
                        <h2 className={styles.categoryTitle}>{t('date')}</h2>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <ThemeProvider theme={newTheme}>
                                <DatePicker format='DD-MM-YYYY' />
                            </ThemeProvider>
                        </LocalizationProvider>
                    </div>
                    <div>
                        <h2 className={styles.categoryTitle}>{t('hour')}</h2>
                        <HourSelector
                            hours={time.hours}
                            minutes={time.minutes}
                            handleChange={handleChangeReminder}
                            style={{ border: '1px solid #acacac', borderRadius: '5px', padding: '11px 17px', justifyContent: 'space-between', color: '#777' }}
                        />
                    </div>
                </div>
                <div>
                    <h2 className={styles.categoryTitle}>{t('type_appointment')}</h2>
                    <Select
                        selector={(props) => <SelectorSimple {...props} />}
                        options={[]}
                        onSelect={() => {/* */ }}
                    />
                </div>
                <div>
                    <h2 className={styles.categoryTitle}>{t('periodicity')}</h2>
                    <Select
                        selector={(props) => <SelectorSimple {...props} />}
                        options={[]}
                        onSelect={() => {/* */ }}
                    />
                </div>
                <div>
                    <h2 className={styles.categoryTitle}>{t('date_duration')}</h2>
                    <Select
                        value={duration === undefined ? '' : duration + ' ' + t('minutes')}
                        options={durationOptions}
                        onSelect={handleClickDuration}                        
                    />
                </div>
                <div>
                    <h2 className={styles.categoryTitle}>{t('reminder')}</h2>
                    <Select
                        selector={(props) => <SelectorSimple {...props} />}
                        options={[]}
                        onSelect={() => {/* */ }}
                    />
                </div>
            </div>
            <div className={styles.description}>
                <h2 className={styles.categoryTitle}>{t('description_appointment')}</h2>
                <textarea className={styles.textArea} />
            </div>
            <CancelConfirmButtons
                onCancel={() => {/* */ }}
                onConfirm={() => {/* */ }}
                customStyles={{ marginTop: '2rem' }}
                customButtonStyles={{ lineHeight: '2rem' }}
            />
        </div>
    );
};

export default CreateEventDialog;